<div
  class="row"
  style="
    background-color: white;
    padding: 10px;
    padding-top: 12px;
    margin-top: 1px;
    margin-right: 2px;
    margin-left: 2px;
  "
  *ngIf="!header"
>
  <div class="col-lg-2" style="padding: 0px">
    <table>
      <tr>
        <td>
          <span
            [inlineSVG]="'./assets/media/svg/icons/Code/Warning-2.svg'"
            *ngIf="workflow.show_alert"
            class="svg-icon svg-icon-md svg-icon-warning"
            matTooltip="the request has been in this state for more than 72 hours."
          >
          </span>
          <div *ngIf="!workflow.show_alert" style="min-width: 30px"></div>
        </td>
        <td>
          <a (click)="clickPin(workflow.workflow_queue); $event.stopPropagation()">
            <span [class]="getPinCSS(workflow.workflow_queue)"
              ><!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2020-12-28-020759/theme/html/demo1/dist/../src/media/svg/icons/Communication/Clipboard-check.svg--><svg
                xmlns="http://www.w3.org/2000/svg"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <rect x="0" y="0" width="24" height="24" />
                  <path
                    d="M11.6734943,8.3307728 L14.9993074,6.09979492 L14.1213255,5.22181303 C13.7308012,4.83128874 13.7308012,4.19812376 14.1213255,3.80759947 L15.535539,2.39338591 C15.9260633,2.00286161 16.5592283,2.00286161 16.9497526,2.39338591 L22.6066068,8.05024016 C22.9971311,8.44076445 22.9971311,9.07392943 22.6066068,9.46445372 L21.1923933,10.8786673 C20.801869,11.2691916 20.168704,11.2691916 19.7781797,10.8786673 L18.9002333,10.0007208 L16.6692373,13.3265608 C16.9264145,14.2523264 16.9984943,15.2320236 16.8664372,16.2092466 L16.4344698,19.4058049 C16.360509,19.9531149 15.8568695,20.3368403 15.3095595,20.2628795 C15.0925691,20.2335564 14.8912006,20.1338238 14.7363706,19.9789938 L5.02099894,10.2636221 C4.63047465,9.87309784 4.63047465,9.23993286 5.02099894,8.84940857 C5.17582897,8.69457854 5.37719743,8.59484594 5.59418783,8.56552292 L8.79074617,8.13355557 C9.76799113,8.00149544 10.7477104,8.0735815 11.6734943,8.3307728 Z"
                    fill="#000000"
                  />
                  <polygon
                    fill="#000000"
                    opacity="0.3"
                    transform="translate(7.050253, 17.949747) rotate(-315.000000) translate(-7.050253, -17.949747) "
                    points="5.55025253 13.9497475 5.55025253 19.6640332 7.05025253 21.9497475 8.55025253 19.6640332 8.55025253 13.9497475"
                  />
                </g>
              </svg>
            </span>
          </a>
        </td>
        <td>
          <span>
            <div
              class="font-weight-bolder font-size-lg mb-0"
              (click)="openEditFlowModal()"
              style="cursor: pointer"
            >
              {{ workflow.workflow_queue.workflow.name | titlecase }}
            </div>
          </span>
        </td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td>
          <div
            *ngIf="workflow.category"
            class="font-size-sm text-muted text-weight-bold"
            style="font-size: 12px"
          >
            Category: {{ getCategoryName(workflow.category) }}
          </div>
        </td>
      </tr>
    </table>
  </div>
  <div class="col-lg-7">
    <div class="row" style="width: 100%">
      <div class="col-lg-4">
        <div *ngIf="workflowPatients.length > 0">
          <span style="width: 126px">
            <span class="text-weight-bold">Patient: </span>
            <span
              class="pr-1 pl-1 text-success gl-block"
              *ngFor="let ent of workflowPatients; let i = index"
              [class.border-right]="i !== workflowPatients.length - 1"
              >{{ getEntity(ent) }}</span
            >
          </span>
        </div>
        <div *ngIf="workflowDoctors.length > 0">
          <span style="width: 126px">
            <span class="text-weight-bold">Doctor: </span>
            <span
              class="pr-1 pl-1 text-success"
              *ngFor="let ent of workflowDoctors; let i = index"
              [class.border-right]="i !== workflowDoctors.length - 1"
              >{{ getEntity(ent) }}</span
            >
          </span>
        </div>
        <div *ngIf="workflowClients.length > 0">
          <span style="width: 126px">
            <span class="text-weight-bold">Client: </span>
            <span
              class="pr-1 pl-1 text-success"
              *ngFor="let ent of workflowClients; let i = index"
              [class.border-right]="i !== workflowClients.length - 1"
              >{{ getEntity(ent) }}</span
            >
          </span>
        </div>
        <div *ngIf="workflowPharmacies.length > 0">
          <span style="width: 126px">
            <span class="text-weight-bold">Pharmacy: </span>
            <span
              class="pr-1 pl-1 text-success"
              *ngFor="let ent of workflowPharmacies; let i = index"
              [class.border-right]="i !== workflowPharmacies.length - 1"
              >{{ getEntity(ent) }}</span
            >
          </span>
        </div>
        <div *ngIf="workflowPharmacyGroups.length > 0">
          <span style="width: 126px">
            <span class="text-weight-bold">Pharmacy Group: </span>
            <span
              class="pr-1 pl-1 text-success"
              *ngFor="let ent of workflowPharmacyGroups; let i = index"
              [class.border-right]="i !== workflowPharmacyGroups.length - 1"
              >{{ getEntity(ent) }}</span
            >
          </span>
        </div>
        <div *ngIf="workflowFacilities.length > 0">
          <span style="width: 126px">
            <span class="text-weight-bold">Facility: </span>
            <span
              class="pr-1 pl-1 text-success"
              *ngFor="let ent of workflowFacilities; let i = index"
              [class.border-right]="i !== workflowFacilities.length - 1"
              >{{ getEntity(ent) }}</span
            >
          </span>
        </div>
      </div>
      <div class="col-lg-2">
        <div>
          <span style="width: 126px" *ngFor="let ent of workflowDrugs">
            <label>{{ getDrug(ent) }}</label>
          </span>
        </div>
      </div>
      <div class="col-lg-2">
        <div>
          <span style="width: 126px" *ngFor="let ent of workflowContacts">
            <label>{{ getContact(ent) }}</label>
          </span>
        </div>
      </div>
      <div class="col-lg-2" style="padding: 0; text-align: center">
        <div class="symbol" [matTooltip]="workflow.workflow_queue.status">
          <span class="mr-10 label label-lg label-light-info label-inline">{{
            workflow.workflow_queue.status.replace(' ', '_') | slice : 0 : 20
          }}</span>
        </div>
      </div>
      <div class="col-lg-2">
        <div class="d-flex align-items-center">
          <div style="width: 24px" class="d-flex flex-center mr-2">
            <img
              *ngIf="workflow.blockers?.length"
              [matTooltip]="getBlockersString(workflow.blockers)"
              src="./assets/media/svg/icons/General/blocker.svg"
              alt="Blocker Icon"
              class="w-100"
            />
          </div>
          <div
            matTooltip="Follow-Up"
            class="symbol symbol-20 cursor-pointer mr-2"
            (click)="openFollowUp($event)"
          >
            <div class="symbol-label bg-transparent">
              <i class="flaticon-calendar-with-a-clock-time-tools icon-lg"></i>
            </div>
            <i *ngIf="workflow.has_followup" class="symbol-badge bg-danger"></i>
          </div>
          <div
            class="symbol symbol-20 cursor-pointer"
            matTooltip="Comments"
            (click)="openComments($event)"
          >
            <div class="symbol-label bg-transparent">
              <i class="flaticon2-chat-1 icon-lg"></i>
            </div>
            <i *ngIf="workflow.has_comments" class="symbol-badge bg-danger"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-1">
    <label style="min-width: 80px; padding-top: 5px" class="ml-1">{{
      workflow.workflow_queue.created | date : 'MMM dd,yyyy @ h:mm a'
    }}</label>
  </div>
  <div class="col-lg-1">
    <table>
      <tr>
        <td>
          <div
            matTooltip="{{ workflow.last_modified_user }}"
            *ngIf="userExist"
            matTooltipPosition="above"
          >
            <kt-user-photo
              [create]="false"
              [size]="30"
              [type]="'object'"
              [editable]="false"
              [user$]="userProfile"
            ></kt-user-photo>
          </div>
        </td>
        <td>
          <button
            *ngIf="locked"
            color="primary"
            matTooltip="Locked by {{ lockedBy }} click to unlock"
            (click)="unlockCard()"
            class="btn btn-icon btn-light btn-hover-danger btn-sm ml-4"
            style="margin-right: 5px; background-color: unset; border: unset"
          >
            <span class="material-icons"> lock </span>
          </button>
        </td>
      </tr>
    </table>
  </div>
  <div class="col-lg-1">
    <div
      *ngIf="assignedUsers.length"
      class="assigned-users symbol-group symbol-hover justify-content-center"
    >
      <div
        *ngIf="assignedUsers.length > 0"
        [matTooltip]="assignedUsers[0].fullName"
        matTooltipPosition="above"
      >
        <kt-user-photo
          [size]="30"
          [create]="'false'"
          [type]="'object'"
          [editable]="false"
          [user$]="assignedUsers[0]"
        ></kt-user-photo>
      </div>
      <div
        *ngIf="assignedUsers.length > 1"
        class="symbol symbol-30 symbol-circle symbol-light-primary"
      >
        <span
          [matTooltip]="getFullNames(assignedUsers, 1)"
          matTooltipPosition="above"
          class="symbol-label font-weight-bold"
        >
          {{ assignedUsers.length - 1 }}+
        </span>
      </div>
    </div>
  </div>
</div>

<div
  class="row rounded-top"
  style="
    background-color: rgba(54, 153, 255, 0.1);
    color: #00aaff;
    padding: 10px;
    padding-top: 12px;
    margin-right: 2px;
    margin-left: 2px;
  "
  *ngIf="header"
>
  <div class="col-lg-2">
    <ng-container
      [ngTemplateOutlet]="columnHeader"
      [ngTemplateOutletContext]="{ column: { label: 'NAME', prop: 'workflow.name' } }"
    ></ng-container>
  </div>
  <div class="col-lg-7">
    <div class="row" style="width: 100%">
      <div class="col-lg-4">
        <ng-container
          [ngTemplateOutlet]="columnHeader"
          [ngTemplateOutletContext]="{ column: { label: 'RELATED', prop: '' } }"
        ></ng-container>
      </div>
      <div class="col-lg-2">
        <ng-container
          [ngTemplateOutlet]="columnHeader"
          [ngTemplateOutletContext]="{ column: { label: 'DRUG', prop: '' } }"
        ></ng-container>
      </div>
      <div class="col-lg-2">
        <ng-container
          [ngTemplateOutlet]="columnHeader"
          [ngTemplateOutletContext]="{ column: { label: 'CONTACT', prop: '' } }"
        ></ng-container>
      </div>
      <div class="col-lg-2">
        <ng-container
          [ngTemplateOutlet]="columnHeader"
          [ngTemplateOutletContext]="{ column: { label: 'STATUS', prop: 'workflow_queue_status' } }"
        ></ng-container>
      </div>
      <div class="col-lg-2">
        <label class="header-title-workflow"></label>
      </div>
    </div>
  </div>
  <div class="col-lg-1">
    <ng-container
      [ngTemplateOutlet]="columnHeader"
      [ngTemplateOutletContext]="{ column: { label: 'CREATED', prop: 'created' } }"
    ></ng-container>
  </div>
  <div class="col-lg-1">
    <ng-container
      [ngTemplateOutlet]="columnHeader"
      [ngTemplateOutletContext]="{ column: { label: 'MODIFIED', prop: 'last_modified_user' } }"
    ></ng-container>
  </div>
  <div class="col-lg-1">
    <ng-container
      [ngTemplateOutlet]="columnHeader"
      [ngTemplateOutletContext]="{ column: { label: 'ASSIGNED', prop: '' } }"
    ></ng-container>
  </div>
</div>

<ng-template #columnHeader let-column="column">
  <div class="col-header" (click)="handleSort($event, column)">
    <table>
      <tr>
        <td>
          <label
            [style.padding-left]="column.label === 'NAME' ? '60px' : '0'"
            style="margin-bottom: 0"
            >{{ column.label }}</label
          >
        </td>
        <td>
          <span *ngIf="column.prop" class="sort-arrows ml-2">
            <i *ngIf="column.label !== sort.label" class="hover-arrow fas fa-arrow-up"></i>
            <i
              *ngIf="column.label === sort.label && sort.type === 'ASC'"
              class="fas fa-arrow-up text-black-50"
            ></i>
            <i
              *ngIf="column.label === sort.label && sort.type === 'DESC'"
              class="fas fa-arrow-down text-black-50"
            ></i>
          </span>
        </td>
      </tr>
    </table>
  </div>
</ng-template>
